import { TRIOLIET_COLORS } from '../triolietThemeConf';
export const triolietSentryReportStyle = {
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]': {
        backgroundColor: `${TRIOLIET_COLORS.success.main} !important`,
        border: 'none !important',
        outline: 'none !important',
    },
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]:hover': {
        backgroundColor: `${TRIOLIET_COLORS.success.dark} !important`,
    },
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]:active': {
        backgroundColor: `${TRIOLIET_COLORS.success.main} !important`,
    },
};
//# sourceMappingURL=triolietSentryReportStyle.js.map